<template>
  <v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >¿Seguro que quieres eliminar este medicamento?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteKBDrug"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title>
      <v-btn
        @click="$router.push({ name: 'KBDrugs' })"
        class="mx-2"
        fab
        dark
        small
        color="primary"
      >
        <v-icon dark>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        @click="
          $router.push({
            name: 'KBDrugRel',
            params: { drugId: kbData.id }
          })
        "
        v-if="drugId != 'nuevo'"
        class="mx-2"
        fab
        dark
        small
        color="orange"
      >
        <v-icon dark>
          mdi-relation-one-or-many-to-one-or-many
        </v-icon>
      </v-btn>
      <v-btn
        v-if="drugId != 'nuevo'"
        @click="
          $router.push({
            name: 'EPGDrugDetail',
            params: { drugId }
          })
        "
        class="mx-2"
        fab
        dark
        small
        color="primary"
      >
        <v-icon dark>
          mdi-book
        </v-icon>
      </v-btn>
      <v-btn @click="submit" class="mx-2" fab dark small color="green">
        <v-icon dark>
          mdi-content-save
        </v-icon>
      </v-btn>
      <v-btn
        @click="dialogDelete = true"
        v-if="drugId != 'nuevo'"
        class="mx-2"
        fab
        dark
        small
        color="red"
      >
        <v-icon dark>
          mdi-delete
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12 px-5" sm="12" md="6">
              <v-card>
                <v-card-title>
                  Nombres principales
                </v-card-title>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="kbData.main_names.en"
                      label="Inglés"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="kbData.main_names.es"
                      label="Español"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="kbData.main_names.po"
                      label="Portugués"
                      required
                    ></v-text-field>
                  </v-col> </v-row
              ></v-card>
              <v-card>
                <v-text-field
                  v-model="kbData.slug"
                  :rules="validationRules.slugRules"
                  label="ID"
                  required
                ></v-text-field>

                <v-text-field v-model="kbData.cas" label="CAS"></v-text-field>

                <v-switch
                  v-model="kbData.hide_in_pgx"
                  label="Ocultar en PGX"
                ></v-switch>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <MultipleInput
                label="Nombres comerciales"
                v-model="kbData.brandnames"
                textField="brandname"
              />

              <MultipleInput
                label="ATCs"
                v-model="kbData.atcs"
                textField="atc"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Strapi from "@/services/Strapi.js";
import MultipleInput from "@/components/mylogy/MultipleInput.vue";
export default {
  props: ["drugId"],
  components: { MultipleInput },
  data() {
    return {
      valid: false,
      dialogDelete: false,
      validationRules: {
        slugRules: [v => !!v || "El campo ID es obligatorio"]
      },
      kbData: {
        atcs: [],
        brandnames: [],
        cas: null,
        dc_concept_relationships: [],
        epg_drug_categories: [],
        has_drug_central: null,
        has_epg: null,
        has_pharm_gkb: null,
        hide_in_pgx: false,
        id: null,
        induces: [],
        inhibits: [],
        kb_inductions: [],
        kb_inhibitios: [],
        kb_relationships: [],
        kb_subs: [],
        main_names: {
          en: null,
          es: null,
          po: null
        },
        pharm_gkb_chemical: null,
        pharmgkb: null,
        slug: null,
        substrate_of: []
      }
    };
  },
  computed: {},
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let self = this;
      if (this.drugId != "nuevo") {
        Strapi.get(`/kb-drugs/${this.drugId}`).then(res => {
          self.kbData = res.data;
        });
      }
    },
    submit() {
      if (this.drugId == "nuevo") {
        this.createKBDrug();
      } else {
        this.updateKBDrug();
      }
    },
    updateKBDrug() {
      let self = this;
      Strapi.put(`/kb-drugs/${self.drugId}`, self.kbData).then(res => {
        self.kbData = res.data;
        fetch(
          `${process.env.VUE_APP_APPBASE_DOMAIN}/${process.env.VUE_APP_DRUGS_CLUSTER}/_update/${res.data.id}`,
          {
            method: "POST",
            mode: "cors",
            body: JSON.stringify({
              doc: {
                EPG_drug_categories: self.kbData.atcs.map(atc => atc.atc),
                Brandnames: self.kbData.brandnames.map(bn => bn.brandname),
                Slug: self.kbData.slug,
                Drug_Name_ES: self.kbData.main_names.es,
                Drug_Name_EN: self.kbData.main_names.en,
                CAS: self.kbData.cas,
                Drug_Name_PO: self.kbData.main_names.po,
                Hide_In_PGX: self.kbData.hide_in_pgx
              }
            }),
            headers: {
              Authorization: `Basic ${window.btoa(
                process.env.VUE_APP_APPBASE_CRED
              )}`,
              "Content-Type": "application/json"
            }
          }
        )
          .then(response => response.json())
          .then(() => {
            self.loadData();
          });
      });
    },
    createKBDrug() {
      let self = this;
      Strapi.post(`/kb-drugs`, this.kbData).then(res => {
        self.kbData = res.data;

        fetch(
          `${process.env.VUE_APP_APPBASE_DOMAIN}/${process.env.VUE_APP_DRUGS_CLUSTER}/_doc/${res.data.id}`,
          {
            method: "POST",
            mode: "cors",
            body: JSON.stringify({
              EPG_drug_categories: self.kbData.atcs.map(atc => atc.atc),
              DC_Ind_PO: [],
              DC_Off_PO: [],
              Induces: [],
              Brandnames: self.kbData.brandnames.map(bn => bn.brandname),
              Slug: self.kbData.slug,
              Drug_Name_ES: self.kbData.main_names.es,
              Has_EPG: false,
              DC_Off_EN: [],
              Drug_Name_EN: self.kbData.main_names.en,
              DC_Ind_EN: [],
              Related: [],
              CAS: self.kbData.cas,
              id: res.data.id,
              DC_Ind_ES: [],
              Substrate_of: [],
              DC_Off_ES: [],
              Drug_Name_PO: self.kbData.main_names.po,
              Has_PGX: false,
              Hide_In_PGX: self.kbData.hide_in_pgx,
              Inhibits: [],
              EPG_drug_categories_string: ""
            }),
            headers: {
              Authorization: `Basic ${window.btoa(
                process.env.VUE_APP_APPBASE_CRED
              )}`,
              "Content-Type": "application/json"
            }
          }
        )
          .then(response => response.json())
          .then(data => {
            self.$router.push({
              name: "KBDrugDetail",
              params: { drugId: data._id }
            });
          });
      });
    },
    deleteKBDrug() {
      let self = this;
      self.dialogDelete = false;
      Strapi.delete(`/kb-drugs/${self.drugId}`, self.kbData).then(res => {
        fetch(
          `${process.env.VUE_APP_APPBASE_DOMAIN}/${process.env.VUE_APP_DRUGS_CLUSTER}/_doc/${res.data.id}`,
          {
            method: "DELETE",
            mode: "cors",
            headers: {
              Authorization: `Basic ${window.btoa(
                process.env.VUE_APP_APPBASE_CRED
              )}`,
              "Content-Type": "application/json"
            }
          }
        )
          .then(response => response.json())
          .then(() => {
            self.$router.push({ name: "KBDrugs" });
          });
      });
    }
  }
};
</script>
<style scoped></style>
